module.exports = "https://bin.bnbstatic.com/_next/static/images/banner-bbdc0fb786d2e2594538c131dd6be0e9.jpg";